module.exports = __webpack_public_path__ + "static/images/e33a7bcf079c84f88001060995a0cc5d.png";